import { render, staticRenderFns } from "./chat-im.vue?vue&type=template&id=18f3bff9&scoped=true&"
import script from "./chat-im.vue?vue&type=script&lang=js&"
export * from "./chat-im.vue?vue&type=script&lang=js&"
import style0 from "./chat-im.vue?vue&type=style&index=0&id=18f3bff9&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18f3bff9",
  null
  
)

export default component.exports